export default __webpack_public_path__ + "static/media/Gandhi150.1692b7f2.png";